'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssComponent = require('react-css-component');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = '\n.display-table-row {\n  display: table-row;\n}\n.display-table-cell {\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n}\n.header-padding {\n  padding: 10px 0 5px 0;\n}\n';

var LineupCardHeader = function LineupCardHeader(props) {
    var headerCols = '';
    if (props.sport === 'pga') {
        headerCols = _react2.default.createElement(
            'div',
            { className: 'display-table-row gray-text small-text' },
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding' },
                'Player'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Ownership'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Salary'
            ),
            _react2.default.createElement('div', { className: 'display-table-cell header-padding center' })
        );
    } else if (props.sport === 'nhl') {
        headerCols = _react2.default.createElement(
            'div',
            { className: 'display-table-row gray-text small-text' },
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding' },
                'Player'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Team'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Salary'
            ),
            _react2.default.createElement('div', { className: 'display-table-cell header-padding center' })
        );
    } else if (props.sport === 'mlb') {
        headerCols = _react2.default.createElement(
            'div',
            { className: 'display-table-row gray-text small-text' },
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding' },
                'Player'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Team'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Order'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Salary'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Projected'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Actual'
            )
        );
    } else {
        headerCols = _react2.default.createElement(
            'div',
            { className: 'display-table-row gray-text small-text' },
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding' },
                'Player'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Team'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Projected'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Own'
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell header-padding center' },
                'Salary'
            ),
            _react2.default.createElement('div', { className: 'display-table-cell header-padding center' })
        );
    }
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_reactCssComponent.UniversalStyle, { css: css }),
        headerCols
    );
};

exports.default = LineupCardHeader;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/lineups/LineupCardRowHeader.js
// module id = 848
// module chunks = 0